import { lockFocus, unlockFocus } from './lock-focus';
import { lockScroll, unlockScroll } from './lock-scroll';

/**
 * @param { HTMLDialogElement } dialog Dialog element to show or hide.
 * @param { boolean } show Whether or not to show the dialog.
 */
export function toggleShowDialog(dialog, show) {
  const body = document.body;
  if(show) {
    dialog.showModal();
    lockScroll(body);
    lockFocus(dialog);
  } else {
    dialog.close();
    unlockScroll(body);
    unlockFocus();
  }
}
